import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
import { useSeo } from '../components/useSeo';
export function AccountantAmsterdamPage() {
  useSeo({
    title: 'Website laten maken voor Accountant in Amsterdam | Noord',
    description: 'Vaste prijs vooraf, lokaal aanspreekpunt en een structurele klantenstroom uit Google. Wij bouwen websites voor accountants in Amsterdam (1-5 medewerkers).',
    canonical: 'https://noorddigital.nl/accountant-amsterdam',
    jsonLd: [{
      '@context': 'https://schema.org',
      '@type': 'ProfessionalService',
      name: 'Noord Digital - Webdesign voor Accountants',
      description: 'Gespecialiseerd webdesign en SEO voor accountantskantoren in Amsterdam.',
      url: 'https://noorddigital.nl/accountant-amsterdam',
      telephone: '+31616265214',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Schuit 8a',
        addressLocality: 'Oudkarspel',
        postalCode: '1724 BD',
        addressCountry: 'NL'
      },
      areaServed: {
        '@type': 'City',
        name: 'Amsterdam'
      }
    }, {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [{
        '@type': 'Question',
        name: 'Wat kost een website voor een accountant in Amsterdam?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Wij werken met een vaste prijs vooraf, zonder verrassingen. Een professionele website voor een accountantskantoor begint vanaf €1.500. Neem contact op voor een vrijblijvende offerte op maat.'
        }
      }, {
        '@type': 'Question',
        name: 'Hoe zorgen jullie voor lokale vindbaarheid in Amsterdam?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Wij optimaliseren je website specifiek voor zoektermen zoals "accountant Amsterdam" en "boekhouder Amsterdam". Dit zorgt voor een structurele stroom aan nieuwe, lokale klanten zonder dat je afhankelijk bent van dure Google Ads.'
        }
      }]
    }]
  });
  return <ClusterPageTemplate clusterName="Accountant Amsterdam" sectorName="Zakelijke Dienstverlening" sectorSlug="zakelijke-dienstverlening" heroTitle="Website laten maken voor een accountant in Amsterdam" heroDescription="Stop met dure Google Ads en marketingbureaus die alleen rapporten sturen. Wij bouwen websites voor accountants in Amsterdam (1-5 medewerkers) die zorgen voor een structurele stroom aan nieuwe klanten uit de regio." websiteOnderdelen={[{
    icon: 'BriefcaseIcon',
    title: 'Diensten',
    description: 'Een overzichtelijke presentatie van jouw accountancydiensten, van jaarrekeningen tot belastingadvies. Laat potentiële klanten direct zien wat je aanbiedt.'
  }, {
    icon: 'UsersIcon',
    title: 'Over ons',
    description: 'Stel je team voor en laat zien wie er achter het kantoor zit. Persoonlijk contact en vertrouwen zijn cruciaal in de accountancy.'
  }, {
    icon: 'PhoneIcon',
    title: 'Contact',
    description: 'Een duidelijke contactpagina met formulier, telefoonnummer en adresgegevens. Maak het zo makkelijk mogelijk om contact op te nemen.'
  }, {
    icon: 'SearchIcon',
    title: 'Lokale SEO Amsterdam',
    description: 'Gerichte landingspagina\'s voor zoektermen als "accountant Amsterdam" of "boekhouder Amsterdam", zodat klanten jou vinden in Google.'
  }]} functionaliteiten={[{
    icon: 'BookOpenIcon',
    title: 'Blog & Kennisbank',
    description: 'Publiceer artikelen over belastingtips en financieel advies. Dit versterkt je autoriteit en verbetert je vindbaarheid in zoekmachines.'
  }, {
    icon: 'SearchIcon',
    title: 'SEO',
    description: 'Technische en inhoudelijke zoekmachineoptimalisatie zodat jouw accountantskantoor gevonden wordt op relevante zoektermen in Amsterdam.'
  }, {
    icon: 'MailIcon',
    title: 'Slimme Formulieren',
    description: 'Contactformulieren die de juiste informatie ophalen, zodat je direct kunt inspelen op de vraag van een potentiële klant.'
  }]} siblingClusters={[]} faqs={[{
    q: 'Wat kost een website voor een accountant in Amsterdam?',
    a: 'Wij werken met een vaste prijs vooraf, zonder verrassingen. Een professionele website voor een accountantskantoor begint vanaf €1.500. Neem contact op voor een vrijblijvende offerte op maat.'
  }, {
    q: 'Hoe lang duurt het om de website te bouwen?',
    a: 'Gemiddeld is een website voor een accountantskantoor binnen 2 tot 4 weken live. Dit hangt af van de omvang van het project en hoe snel wij de benodigde content en materialen ontvangen.'
  }, {
    q: 'Zit ik vast aan een contract?',
    a: 'Nee, wij geloven niet in lock-ins. Je bent 100% eigenaar van je website. Wij bieden optioneel hosting en onderhoud aan, maar je bent vrij om dit zelf te regelen.'
  }, {
    q: 'Word ik ook lokaal gevonden in Amsterdam?',
    a: "Absoluut. Lokale SEO is standaard inbegrepen. We optimaliseren voor zoektermen als 'accountant Amsterdam' of 'boekhouder Amsterdam' voor een structurele klantenstroom."
  }]} data-id="element-1047" />;
}